module.exports = __webpack_public_path__ + "img/googleturtle.096da25b.svg";